
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: '#dcdcdc',
    padding: '1%',
  },

  items: {
    padding: '1%',
    display:'flex',
    flexDirection:'row'
  },

  item_header: {
    fontWeight: 600,
    paddingLeft: '10%',
    width:'50%'
  },

  item_body: {
    padding: '6px ',
    width: '40%',
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    textAlign:'center',
    fontSize:'120%'
  },

  court_list: {
    padding: '1%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent:'space-around',
    borderBottom: '1px solid black',
    width:'100%'
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '40%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/createFixture/style.js